import { useEffect, useState } from 'react';
import './Anime.css';

function Anime({ backImgList, path, backImgId, children, imgClass}) {


    //Field Layer 01 cloud upside down.png
    return (
        <div id="l1" className={imgClass} >
            <div id="l2" className={imgClass} >
                <div id="l3" className={imgClass} >
                    <div id="l4" className={imgClass} >
                        <div id="l5" className={imgClass} >
                            <div id="l6" className={imgClass} >
                                <div id="l7" className={imgClass} >
                                    <div id="l8" className={imgClass} >
                                        <div id="l9" className={imgClass} >
                                            <div id="l10">
                                                <div id="l11" className={imgClass} >
                                                    
                                                    {children}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Anime;